import { cn } from "@prostocheck/shared";

import {
  BUTTON_BASE_CLASS,
  BUTTON_SIZE_CLASS,
  BUTTON_VARIANT_CLASS,
} from "./button.constants";
import { IButtonClassParams } from "./button.models";

export const buttonClass = ({
  variant,
  size,
  className,
}: IButtonClassParams): string =>
  cn(
    BUTTON_BASE_CLASS,
    BUTTON_VARIANT_CLASS[variant],
    BUTTON_SIZE_CLASS[size],
    className,
  );
